import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  Suspense,
  lazy,
} from "react";
import "./herosection.css";
import BlueButton from "./BlueButton";
import APIDocsForm from "./Modals/ApiDocsForm/APIDocsForm";
const Grid = lazy(() => import("animated-grid-lines"));

function Herosection() {
  const [scrolledIn, setScrolledIn] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const scrolledInRef = useRef(false);

  const handleScroll = () => {
    requestAnimationFrame(() => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const isScrolled =
        scrollY >= viewportHeight * 0.02 && scrollY <= viewportHeight * 0.5;

      if (scrolledInRef.current !== isScrolled) {
        scrolledInRef.current = isScrolled;
        setScrolledIn(isScrolled);
      }
    });
  };

  const handleScrollToViewPort = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="hero-section-container">
      <Suspense fallback={<div>...</div>}>
        <Grid
          colors={["#00FFFF"]}
          speed={20}
          squareSize={100}
          maxLineLength={100}
          lineWidth={0.5}
          gridColor="rgba(255, 255, 255, 0.1)"
          className="animated-gridview"
        />
      </Suspense>

      <div className="hero-section-wrapper">
        <div className="main_hero_section">
          <div className="hero-section-text-container">
            <div
              className={`hero-section-images ${
                scrolledIn && " animate-image"
              }`}
            >
              <img src="/images/textcoverimage1.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage2.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage3.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage4.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage6.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage5.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage7.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage8.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage9.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage10.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage11.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage12.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage13.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage14.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage15.svg" alt="" loading="lazy" />
              <img src="/images/textcoverimage16.svg" alt="" loading="lazy" />
            </div>
            <div
              className={`hero-section-text-inner-container ${
                scrolledIn && "animate-image"
              }`}
            >
              Go Beyond
            </div>
            <div className="hero-section-subheading">
              KYC & KYB Verification APIs{" "}
            </div>
            <p>
              Enabling companies to prevent fraud, verify identity & target the
              right set of users. We use authorised sources to match user
              records .
            </p>
            <div className="hero-section-btn-group">
              <BlueButton
                text={"Book a Demo"}
                styles={{
                  width: "100%",
                  textWrap: "nowrap",
                  pointerEvents: "auto",
                  backgroundImage:
                    "radial-gradient(circle at 50% 50%, #DFFF8E, #AFF500 91%)",
                  color: "#25016E",
                }}
                onClick={() => handleScrollToViewPort("book-a-demo")}
              />

              <BlueButton
                onClick={() => setModalOpen(true)}
                text={"See API Documentation"}
                styles={{
                  textWrap: "nowrap",
                  pointerEvents: "auto",
                  width: "100%",
                  background: "#fff",
                  color: "#4200BF",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <APIDocsForm
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        key={"modal"}
      />
    </section>
  );
}

export default React.memo(Herosection);
